import { render, staticRenderFns } from "./planDetail.vue?vue&type=template&id=7830ea22"
import script from "./planDetail.vue?vue&type=script&lang=js"
export * from "./planDetail.vue?vue&type=script&lang=js"
import style0 from "./planDetail.vue?vue&type=style&index=0&id=7830ea22&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports